import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSkills } from '../../Apis/content';

export const SkillsList = createAsyncThunk('skilllsss', async (token, { rejectWithValue }) => {
    try {
        const response = await getSkills(token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const skilSlice = createSlice({
    name: 'skil',
    initialState: {
        error: null,
        success: false,
        data: [],
    },
    reducers: {
        clearSkilStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(SkillsList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(SkillsList.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(SkillsList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearSkilStatus } = skilSlice.actions;
export default skilSlice.reducer;

